import { Component, Input } from '@angular/core';
import { CompletedCareerPlan, CompletedCareerPlans } from 'src/app/models/career-plans';
import { CareerPlanHistoryService } from './career-plan-history.service';
import { Params } from '@angular/router';

@Component({
  selector: 'app-career-plan-history',
  templateUrl: './career-plan-history.component.html',
  styleUrls: ['./career-plan-history.component.scss'],
})
export class CareerPlanHistoryComponent {
  @Input()
  completedCareerPlans: CompletedCareerPlans;

  careerPlanLabel: string = 'careerPlans.label.name';
  pageName = 'user/career-plans/plan-history-item';

  constructor(private careerPlanHistoryServic: CareerPlanHistoryService) {}

  buildQueryParams(careerPlan: CompletedCareerPlan): Params {
    return {
      completedCareerPlan: JSON.stringify(careerPlan),
    };
  }

  downloadCertificate(certificateUrl: string) {
    this.careerPlanHistoryServic.downloadCertificate(certificateUrl);
  }
}
